const state = {

    Projects : []
    
  }
  
  const mutations = {
    SetProjects(state, payload){
        state.Projects = payload
    },
    SetIndividualProjects(state, payload){
        state.Projects.push(payload)
    },
    UpdateIndividualProjects(state, payload){

        let index = state['Projects'].findIndex(x => x["_id"] == payload["_id"])
        state['Projects'].splice(index,1,payload)
    },
    DeleteIndividualProjects(state, payload){

        let index = state['Projects'].findIndex(x => x["_id"] == payload["Project_Id"])
        state['Projects'].splice(index,1)
    }

  }
  
  const actions = {
    
  }
  
  const getters = {

    GetProjects(state){

        return state.Projects
      }
  }
  
  export default {
    state,
    mutations,
    actions,
    getters
  }
  